import FileServiceModel   from '@/models/FileServiceModel';
import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';
import SourceModel        from './SourceModel';
import TypeModel          from './TypeModel';

@model.urnResource('type_source')
@doc.path('/stonecode_file_type_sources/{?id}')
export default class TypeSourceModel extends FileServiceModel {
	public declare _tsFilters: {
		'locked': '0' | '1';
		'source': id;
		'source.entityUrn': id;
		'type': id;
		'type.deprecated': '0' | '1';
		'type.reference': FileTypeReference;
		'type.service': id;
		'type.service.serviceUrn': string;
		'type.system': '0' | '1';
	};

	public declare _tsSorts: {
		'id': string;
		'updatedAt': string;
	};

	@doc.model(SourceModel) declare source: SourceModel;
	@doc.model(TypeModel) declare type: TypeModel;

	public get sourceId() {
		return this.get('source.id');
	}
}
